import React, { useState } from "react";
import style from "./banner1.module.css";
import graph from "../../assets/graph.png";
import HeadingAnimation from "../../components/animations/heading";
import SubHeadingAnimation from "../../components/animations/subHeading";
import ButtonAnimation from "../animations/button";

const Banner1 = () => {
  const heading = "Borderless digital payments";
  const sub =
    "Zero knowledge payments that provide cross-border solutions for seamlessly processing digital transactions.";
  const [headingCompleted, setHeadingCompleted] = useState(false);

  return (
    <div className={style.card} id="individual">
      <div className={style.left}>
        <HeadingAnimation
          text={heading}
          transitionDuration={0.5}
          className={style.heading}
          setHeadingCompleted={setHeadingCompleted}
        />
        {headingCompleted && (
          <SubHeadingAnimation
            text={sub}
            className={style.sub}
            transitionDuration={0.35}
          />
        )}
      </div>
      <div className={style.right}>
        <img src={graph} alt="img" className={style.img} />
        <ButtonAnimation
          className={style.button}
          handleButton={() =>
            window.open("http://auth.nublock.xyz/businessportal ", "_blank")
          }
          text="Get Started"
        />
      </div>
    </div>
  );
};

export default Banner1;
